<template>
<!-- 视频管理 Tab -->
  <div id="feedFlareList">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto;white-space: normal">
          <p>
            <input class="allInput" placeholder="请输入配置名字" type="text" v-model="searchData.name">
          </p>
          <button class="redButton" @click="getList(1)">搜索</button>
        </div>
        <div style="width: auto">
          <button class="redButtonTwo" @click="newVideos">新建</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <table cellspacing="0" class="allTable" style="table-layout: fixed;">
          <thead>
            <tr>
              <th width="10%">序号</th>
              <th width="20%">配置名称</th>
              <th width="30%">跳转地址</th>
              <th width="10%">添加人</th>
              <th width="5%">排序</th>
              <th width="15%">添加时间</th>
              <th width="10%">操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="myList.length > 0">
              <tr :key="index" v-for="(item, index) in myList">
                <td  class="NoWrap" :title="item.id">{{index + 1}}</td>
                <td  class="NoWrap" :title="item.name">{{item.name}}</td>
                <td  class="NoWrap" style="max-width: 250px" :title="item.redirectUrl">{{item.redirectUrl}}</td>
                <td  class="NoWrap" :title="item.creator">{{item.creator}}</td>
                <td  class="NoWrap">{{item.sort}}</td>
                <td  class="NoWrap">{{item.creationTime}}</td>
                <td ><div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <!-- <li @click="viewListItem(item)">查看</li> -->
                    <li @click="editListItem(item)">编辑</li>
                    <li @click="deleteDraftItem(item)">删除</li>
                  </ul>
                </div></td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td style="border: none; text-align: center;" :colspan="8">暂无数据</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>
    <!-- 新建项目 -->
    <model v-if="showModel" :buttonType="0" :title="modelTitle" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="width:100%; box-sizing:border-box; padding:10px 40px;">
        <ul class="allUL">
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>配置名称</span>
            <input v-model="modelData.name" type="text" class="allInput" max="8" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="0/8" />
          </li>

          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>跳转地址</span>
							<input v-model="modelData.redirectUrl" type="text" class="allInput" style="width: calc(100% - 110px); margin-left: -30px;" placeholder="请输入跳转地址" />
          </li>
          <li>
            <span style="font-size:16px"><i class="colorRed m_r_5">*</i>排序</span>
							<input v-model="modelData.sort" type="number" class="allInput" style="width: calc(100% - 110px); margin-left: -30px; " placeholder="请输入排序" />
          </li>
        <li class="m_t_10">
          <div style="width: 110px;font-size:16px" :class="modelData.isRotation ? 'required' : ''" class="d_in"><i class="colorRed m_r_5">*</i>上传图片</div>
          <div style="white-space: nowrap;width: calc(100% - 110px); margin-left: -20px;" class="d_in">
            <!-- <input type="text" class="allInput w100 p_8 b_b" placeholder="请输入直播名称"/> -->
              <input @change="clopuploadImg($event,2)" type="file" id="inFile" class="coverFile" accept="image/*"/>
              <label style="width: 125px;height: 125px;" for="inFile">
                <div v-if="modelData.coverUrl">
                  <img :src="modelData.coverUrl.indexOf('http') > -1 ? modelData.coverUrl : baseUrl + `/api/ThirdPartyRedirect/GetFile?filepath=${modelData.coverUrl}`" width="125" height="125" style="border-radius: 8px"/>
                </div>
                <div v-else style="margin-top: 20px">
                  <span style="color: #DCDCDC;font-size: 50px">+</span>
                </div>
              </label>
              <div class="d_i" style="width: calc(100% - 125px);white-space: normal;">建议上传图片比例100*100</div>
          </div>
        </li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
  export default {
    name: 'feedFlareList',
    data () {
      return {
        CNmode: true,
        baseUrl: process.env.config.baseUrl,
        token: window.sessionStorage.getItem('token'),token: window.sessionStorage.getItem('token'),
        searchCate: [{
          id: '',
          name: '全部',
          productName: '全部'
        }],
        totalPage: 1,
        totalCount: 0,
        page: 1,
        searchData: {
          name: '',
          fromwechat: false,
          pageindex: 1,
          pagesize: 10
        },
        myList: [],
        modelTitle: '',
        modelType: '',
        showModel: false,
        modelData: {
					name: "",
					redirectUrl: "",
					coverUrl: "",
					sort: ''
        },
				showImg: ''
      }
    },
    created () {
      // 获取列表
      this.getList()
    },
    methods: {
			async getFile (){
				this.showImg = await this.$axiox.asyncGet(`/api/ThirdPartyRedirect/GetFile?filepath=${this.searchData.coverUrl}`)
			},
      // 获取视频列表
       getList (page = 1) {
        this.searchData.pageindex = page
        let params = JSON.parse(JSON.stringify(this.searchData))
        this.$axiox.getList(this.$commonJs.returnQuery(`/api/ThirdPartyRedirect/query`, params)).then(res => {
          console.log(res, 'getList')
          if (res.data) {
            this.myList = res.data
            this.totalPage = Math.ceil(res.total / this.searchData.pagesize)
            this.totalCount = res.total
          } else {
            this.myList = []
            this.totalPage = 0
            this.totalCount = 0
          }
        })
      },
      // 新建项目
      newVideos () {
        this.modelTitle = '新建配置'
        this.modelType = 'new'
        this.showModel = true
				this.modelData = {
					name: "",
					redirectUrl: "",
					coverUrl: "",
					sort: ''
				}
      },
		clopuploadImg (e) {
      // 上传图片
      var file = e.target.files[0]
      this.signalUpload(file)
    },
    async signalUpload (e) {
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.modelData.coverUrl = await this.$commonJs.uploadFile(fileImg, '/api/ThirdPartyRedirect/upload/cover', 'formFile')
        document.getElementById('inFile').value = ''
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
      confirModel () {
        console.log(this.modelData, 'confirModel')
        this.modelData.name = this.modelData.name.trim()
        if (!this.modelData.name || !this.modelData.redirectUrl || !this.modelData.coverUrl || !this.modelData.sort) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: '请检查必填项',
            stayTime: 5
          })
          return
        }
        if (this.modelType == 'new') {
          let params = JSON.parse(JSON.stringify(this.modelData))
					params.coverUrl = params.coverUrl.indexOf('http') > -1 ? params.coverUrl : `${this.baseUrl}/api/ThirdPartyRedirect/GetFile?filepath=${params.coverUrl}`
					params.sort = Number(params.sort)
          this.$axiox.post(`/api/ThirdPartyRedirect/add`, params).then(res => {
            this.getList(1)
            this.showModel = false
          })
        } else if (this.modelType == 'edit') {
          let params = JSON.parse(JSON.stringify(this.modelData))
					params.coverUrl = params.coverUrl.indexOf('http') > -1 ? params.coverUrl : `${this.baseUrl}/api/ThirdPartyRedirect/GetFile?filepath=${params.coverUrl}`
					params.sort = Number(params.sort)
          this.$axiox.post(`/api/ThirdPartyRedirect/edit`, params).then(res => {
            this.getList(1)
            this.showModel = false
          })
        }
      },
      cancelModel () {
        this.showModel = false
      },
      getVideoItemById (id) {
        this.$axiox.get(`/api/ThirdPartyRedirect/detail/${id}`).then(res => {
          this.modelData = res
        })
      },
      // 编辑项目
      editListItem (item) {
        this.getVideoItemById(item.id)
        this.modelTitle = '编辑配置'
        this.modelType = 'edit'
        this.showModel = true
      },
      // 删除轮播图
      deleteDraftItem (item) {
        console.log(item, 'deleteDraftItem')
        this.$commonJs.doubleComfirm({
          content: '是否确定删除此配置？',
          successFun: msg => {
            this.$axiox.post('/api/ThirdPartyRedirect/delete/' + item.id).then(msg => {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '删除成功',
                stayTime: 5
              })
              // 获取视频列表
              this.getList(1)
            })
          },
          errorFun: msg => {
          }
        })
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/feedFlareManage/feedFlareList.vue